(function() {
  'use strict';
  
  angular
    .module('plugins.q-and-a')
    .controller('QAndAPollViewController', QAndAPollViewController);
      
  QAndAPollViewController.$inject = [
    '$log', 
    '$scope', 
    'pollPluginService',
    'auth'
  ];
    
  function QAndAPollViewController(
      $log, 
      $scope, 
      pollPluginService,
      auth
    ) {
    $log = $log.getInstance('QAndAPollViewController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.submitQuestion = submitQuestion;
    vm.toggleUpvote = toggleUpvote;
    vm.questions = []

    var userId = auth.user()._id;
    
    activate();
    
    function activate() {
      pollPluginService.getPreviousResponses($scope.result._id)
        .then(function(responses){
          responses.forEach(function(response) {
            if (response.data.question)
              vm.questions.push(response);
            else if (response.user === userId)
              findAndUpvote(response.data.upvote)
          })
        })
      pollPluginService.onResponseReceived($scope, $scope.result._id, _onResponseReceived);
    }
    
    function submitQuestion(question) {
      if (!question) return
      pollPluginService.submitResponse($scope.result._id, {question: question, upvotes: []}, true)
      vm.question = ""
      $log.info('Submitted question: ', question);
    }

    function toggleUpvote(question) {
      pollPluginService.submitResponse($scope.result._id, {upvote: question._id}, true);
      $log.info('Upvoted question: ', question);
    }

    function _onResponseReceived(response) {
      if (response.data.question) {
        vm.questions.push(response);
      } else if (response.user === userId) {
        findAndUpvote(response.data.upvote)
      }
    }

    function findAndUpvote(questionId) {
      _.each(vm.questions, function(q) {
        if (q._id === questionId) {
          var index = q.data.upvotes.indexOf(userId)
          if (index === -1) {
            q.data.upvotes.push(userId);
            q.upvoted = true;
          } else {
            q.data.upvotes.splice(index, 1)
            q.upvoted = false;
          }
        }
      })
    }
  }
  
})();